<div class="dsg-save-as-dialog">
  <header class="dsg-save-as-head">
    <span class="dsg-save-as-icon"><mat-icon>create_new_folder</mat-icon></span>
    <div>
      <h2 mat-dialog-title>Create a new project</h2>
      <p>Projects keep related dashboards together. This dashboard will be filed under the new project.</p>
    </div>
  </header>

  <mat-dialog-content>
    <mat-form-field appearance="outline" subscriptSizing="dynamic">
      <mat-label>Project name</mat-label>
      <input
        matInput
        cdkFocusInitial
        maxlength="120"
        placeholder="e.g. Sales Performance"
        [(ngModel)]="name"
        (input)="error = ''"
        (keyup.enter)="create()"
        aria-label="Project name"
      />
      <mat-hint *ngIf="!error">You can switch a dashboard to another project at any time.</mat-hint>
    </mat-form-field>
    <p class="dsg-dialog-error" role="alert" *ngIf="error">{{ error }}</p>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button mat-button type="button" (click)="cancel()">Cancel</button>
    <button mat-flat-button type="button" class="dsg-save-as-submit" (click)="create()">
      <mat-icon>add</mat-icon>
      Create project
    </button>
  </mat-dialog-actions>
</div>
